import { Modal } from "antd";
import React from "react";
import { OrderReceipt } from "../manual/Receipt";
import { useBoolean } from "hooks/useBoolean";
import Button from "Components/Button";
import { OrderDetails } from "hooks/OrderManagement/useOrders";

type DownloadReceiptProps = {
  data: OrderDetails;
};
export const DownloadReceipt = ({ data }: DownloadReceiptProps) => {
  const [showReceiptModal, setReceiptModal] = useBoolean(false);

  if (!data) return null;

  return (
    <div>
      <Button label="Download Receipt" onClick={setReceiptModal.on} />
      <Modal
        open={showReceiptModal}
        onCancel={setReceiptModal.off}
        closable={false}
        footer={null}
        className="p-0 print:invisible !w-[350px]">
        {/* TODO: fix branch */}
        {/* @ts-expect-error missing branch */}
        <OrderReceipt order={{ ...data, branch: {} }} />
      </Modal>
    </div>
  );
};
